import { Shield, Users, Zap } from "lucide-react";
import { HomeEconomySimulator } from "./economy-simulator/HomeEconomySimulator";
import FaleComEspecialistaForm from "./ui/FaleComEspecialistaForm";

const HeroSection = () => {
  return (
    <section
      id="simulador-economia-landing"
      className='relative bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50 py-20 overflow-hidden scroll-mt-24'
    >
      {/* Background Pattern */}
      <div className='absolute inset-0'>
        <img
          src='/hero-background.webp'
          alt='Solar panels background'
          className='w-full h-full object-cover'
          width={1280}
          height={623}
          fetchPriority='low'
          decoding='async'
        />
        <div className='absolute inset-0 bg-gray-900/70' />
      </div>

      <div className='relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16'>
          {/* Content */}
          <div>
            {/* Main Headline */}
            <h1 className='text-4xl md:text-5xl font-display font-bold text-white mb-6 leading-tight lg:text-4xl'>
              Somos a maior plataforma de{" "}
              <span className='bg-gradient-to-r from-thopen-pink to-thopen-yellow bg-clip-text text-transparent'>
                energia livre
              </span>{" "}
              do Brasil transformando conhecimento em liberdade
            </h1>

            {/* Subheadline */}
            <div className='space-y-4 mb-8'>
              <p className='text-xl text-white font-medium'>
                Descubra porque que consumidores de todo Brasil escolhem a Thopen{" "}
                <strong>para economizar na conta de energia</strong>
              </p>
            </div>

            {/* CTAs */}
            {/* <div className='flex flex-col sm:flex-row gap-4 mb-8'>
              <FaleComEspecialistaForm buttonClassName='border-2 border-white text-white px-6 py-3 rounded-lg font-display font-semibold text-base hover:bg-white hover:text-gray-900 transition-all duration-200 text-center hover:scale-105 transform whitespace-nowrap' />
            </div> */}

            {/* Social Proof */}
            <div className='flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white'>
              <div className='flex items-center space-x-2'>
                <Users className='h-4 w-4 text-thopen-pink' />
                <span>Gestão energética em escala nacional</span>
              </div>
              <div className='flex items-center space-x-2'>
                <Shield className='h-4 w-4 text-thopen-yellow' />
                <span>100% aprovado pela ANEEL</span>
              </div>
              <div className='flex items-center space-x-2'>
                <Zap className='h-4 w-4 text-thopen-pink' />
                <span>Energia Limpa</span>
              </div>
            </div>
          </div>

          {/* Simulator */}
          <div className='flex justify-center lg:justify-end'>
            <HomeEconomySimulator />
          </div>
        </div>
      </div>
    </section>
  );
};
export default HeroSection;
